<template>
  <div>
    <Fieldset :legend="translate('languages', 'ucfirst')"
      class="w-full px-5 pb-4 mt-5 bg-white rounded-lg shadow-md border border-color-iron">
      <Skeleton v-if="isLoading && idioms" height="1.5rem" class="mb-2"></Skeleton>
      <ul v-else-if="!isLoading && idioms.length > 0">
        <li>
          <div v-for="(idiom, index) in idioms" :key="index"
            class="flex flex-col gap-y-3 capitalize mb-2.5">
            <span class="font-medium">{{ idiom.language_name }}</span>
            <span class="font-normal -mt-3">({{ singleProficiency(idiom.speaking).title }})</span>
          </div>
        </li>
      </ul>
      <ul v-else>
        <li class="font-medium">
          {{ translate('no languages', 'ucfirst') }}
        </li>
      </ul>
    </Fieldset>
  </div>
</template>

<script setup>
import { ref, onMounted, onUpdated } from 'vue'
import Fieldset from "primevue/fieldset";
import Skeleton from 'primevue/skeleton';
import { translate } from "@/composables/translate";
import useLanguageProficiency from "@/composables/LanguageProficiency";

const props = defineProps({
  languages: {
    type: Array,
    required: true,
    default: () => [],
  }
});


let idioms = ref([])
let isLoading = ref(false)
let { singleProficiency } = useLanguageProficiency()


onUpdated(() => {
  isLoading.value = false
  if (props.languages.length > 0) idioms.value = props.languages
})

onMounted(() => {
  isLoading.value = true
});
</script>

<style scoped></style>